import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import MenuList from '../MenuList';

class NavBar extends React.PureComponent {
  handleClick = (e) => {
    e.preventDefault();
    this.props.onOpenSide();
  }
  render() {
    const { tt, list, lang, openSide, locale } = this.props;
    return (
      <div className="navbar-fixed">
        <nav>
          <div className="container">
            <div className="nav-wrapper">
              <Link to={`/${locale}`} className="brand-logo">
                <img src={logo} alt="logo" />
              </Link>
              {
                this.props.isHome &&
                <a onClick={this.handleClick} href="" className="button-collapse">
                  <i className="material-icons">{openSide ? 'close' : 'menu'}</i>
                </a>
              }
              <ul className="right">
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://mrrichbakery.myshopify.com/collections/frontpage?winzoom=1"
                  >
                    <span>{tt.shopNow}</span>
                  </a>
                </li>
              </ul>
              {
                this.props.isHome &&
                <MenuList
                  tt={tt}
                  list={list}
                  lang={lang}
                  className="right hide-on-med-and-down"
                />
              }
            </div>
          </div>
        </nav>
      </div>
    );
  }
}


NavBar.propTypes = {
  tt: PropTypes.object,
  lang: PropTypes.array,
  list: PropTypes.array,
  isHome: PropTypes.bool,
  locale: PropTypes.string,
  openSide: PropTypes.bool,
  onOpenSide: PropTypes.func,
};

NavBar.defaultProps = {
  tt: {},
  lang: [],
  list: [],
  isHome: false,
  locale: '',
  openSide: false,
  onOpenSide: () => {},
};


export default NavBar;



// WEBPACK FOOTER //
// ./src/blocks/NavBar/index.js